export const getDeviceType = (): 'mobile' | 'desktop' => {
  return /Mobi|Android|iPhone|iPod/i.test(navigator.userAgent) ? 'mobile' : 'desktop';
};
